export default {
    StatusDisplay: {
        f3: 'F3 - Tìm nhanh',
        f9: 'F9 - Thêm nhanh',
        ctrl_f2: 'Ctrl+F2 - Xem số tồn',
        ctrl_2: 'Ctrl+2 - Sao chép cho các dòng phía sau',
		ctrl_4: 'Ctrl+4 - Tính lại thành tiền theo đơn giá sau thuế',
		f6: 'F6 - Chọn mã quy cách',
		f8: 'F8 - Chọn chứng từ nhập',
    },
    Tooltip: {
        Add: 'Thêm (Crtl + 1)',
        Edit: 'Sửa (Ctrl + E)',
        Delete: 'Xóa (Ctrl + D)',
        Save: 'Cất (Ctrl + S)',
        SaveAndAdd: 'Cất và thêm (Ctrl + Shift + S)',
        SaveAndPost: 'Cất và ghi sổ (Ctrl + Shift + G)',
        SaveAndPrint: 'Cất và in (Ctrl + Shift + P)',
        Duplicate: 'Nhân bản (Ctrl + Shift + C)',
        Post: 'Ghi sổ (Ctrl + G)',
        UnPost: 'Bỏ ghi (Ctrl + Shift + G)',
        Help: 'Giúp (F1)',
        Close: 'Đóng (ESC)',
        Undo: 'Hoãn (Ctrl + U)',
    }
}
